import { USER_ENDPOINTS } from "./endpoints";
import type { LogoutResponse } from "./types";
import { apiPost } from "../shared";

export default async function logoutUser(): Promise<LogoutResponse> {
  await apiPost(USER_ENDPOINTS.LOGOUT);

  localStorage.clear();
  sessionStorage.clear();
  window.dispatchEvent(new Event("authChange"));

  return { success: true, message: "Logout successful" };
}
